import CartPromocodePresenter from "../components/cart-promocode/presenter/cart-promocode.js";

const formElement = document.querySelector(`.cart-promocode-form`);

if (formElement) {
  const cartPromocodeComponent = new CartPromocodePresenter(formElement);
  cartPromocodeComponent.init();
}

